module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Screen.js"));
	}, "Screen");
}